export default "__VITE_ASSET__d8b312fa__"